import { getFirestore, collection, query, where, orderBy, getDocs, getDoc, doc } from "firebase/firestore";
import { firebaseApp } from "../../firebase"; // adjust based on where you init Firebase

const db = getFirestore(firebaseApp);

function shuffleArray(array) {
  return array
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
}

const getUserByRef = async (userRef) => {
  if (!userRef) return null;
  const userSnap = await getDoc(userRef);
  return userSnap.exists() ? { id: userSnap.id, ...userSnap.data() } : null;
};


export const getApprovedTicketingWithUser = async () => {
  const q = query(
    collection(db, "TicketingEvent"),
    where("status", "==", "Approve"),
    orderBy("eventEndDate", "desc")
  );

  const snapshot = await getDocs(q);
  const ticketings = await Promise.all(
    snapshot.docs.map(async (docSnap) => {
      const ticketingData = docSnap.data();
      const user = await getUserByRef(ticketingData.eventOwner);
      return {
        id: docSnap.id,
        ...ticketingData,
        eventOwner: user, // add full user data
      };
    })
  );

  return ticketings;
}

export const getTicketingById = async (id) => {
  try {
    const docRef = doc(db, "TicketingEvent", id);      // <-- Use modular doc() here
    const docSnap = await getDoc(docRef);     // <-- Use getDoc()

    if (!docSnap.exists()) return null;       // <-- call exists() as a method

    const ticketingData = docSnap.data();
    const user = await getUserByRef(ticketingData.eventOwner);    
    return {
      id: docSnap.id,
      ...ticketingData,
      eventOwner: user
    };
  } catch (error) {
    console.error("Error fetching rental by ID:", error);
    return null;
  }
};

export const getRandomApprovedTicketingWithUser = async () => {
  const q = query(
    collection(db, "TicketingEvent"),
    where("status", "==", "Approve"),
    orderBy("eventEndDate", "desc")
  );

  const snapshot = await getDocs(q);

  const shuffledDocs = shuffleArray(snapshot.docs).slice(0, 5);

  const ticketings = await Promise.all(
    shuffledDocs.map(async (docSnap) => {
      const ticketingData = docSnap.data();
      const user = await getUserByRef(ticketingData.eventOwner);
      return {
        id: docSnap.id,
        ...ticketingData,
        eventOwner: user,
      };
    })
  );

  return ticketings;
};
